import { render, staticRenderFns } from "./ReagentRunFree.vue?vue&type=template&id=03132d58&scoped=true&"
import script from "./ReagentRunFree.vue?vue&type=script&lang=js&"
export * from "./ReagentRunFree.vue?vue&type=script&lang=js&"
import style0 from "./ReagentRunFree.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ReagentRunFree.vue?vue&type=style&index=1&id=03132d58&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03132d58",
  null
  
)

export default component.exports